/* eslint-disable react/prop-types */
import React, { useState } from 'react';

import { SomaIcon } from '@soma/react';

import { P } from 'xpi-black-ui/Base/Typography';
import { Row, Col } from 'xpi-black-ui/Base/Grid';
import KeyValue from 'xpi-black-ui/Common/KeyValue';
import ContentBox from 'xpi-black-ui/Base/ContentBox';

import Glossary from './Glossary';

import { Container, Wrapper } from './styles';

// eslint-disable-next-line react/prop-types
function Informations({ product }) {
  const [showAllTextInformations, setShowAllTextInformations] = useState(false);

  return (
    <Container>
      <ContentBox>
        <P bigger bold className="margin-bottom">Informações adicionais</P>
        <P className={`margin-bottom ${!showAllTextInformations ? 'hide-text' : ''}`}>
          - Cliente precisa ter os termos de operações estruturadas e, para operações com compra de ativo com vencimento até um ano, perfil
          {product.codigoCamaraCompensasao !== 2 ? ' moderado e ' : ' '}
          agressivo no suitability. Demais operações, perfil agressivo no suitability.
          <br />
          - A XP Investimentos CCTVM esclarece que as operações estruturadas são realizadas por clientes com experiência no mercado de capitais e com o perfil de risco adequado, sendo certo que os preços de tais operações, que são meramente indicativos, podem envolver riscos consideráveis de oscilação da moeda.
          <br />
          - A XP Investimentos CCTVM possui área dedicada a produtos estruturados, com o objetivo de oferecer operações de hedge (proteção) ou especulação. Atenção: este produto é destinado a clientes com perfil de investimento adequado à operação, conforme citado acima, sendo este o público a que se destina o presente material.
          <br />
          - Os custos envolvidos na operação poderão ser posteriormente consultados na nota de corretagem. Para as demais tarifas, consulte www.xpi.com.br/custos-operacionais. A consulta a operação deve ser feita na área de clientes no portal da XP. Caso queria desfazer ou reduzir sua posição, solicite uma cotação ao seu assessor.
          <br />
        </P>

        {!showAllTextInformations ? (
          <>
            <Row justifyContent="center" onClick={() => setShowAllTextInformations(true)}>
              <P bold style={{ cursor: 'pointer' }}>Ver mais informações</P>
              <SomaIcon icon="plus-circle" size="sm" color="#FFC709" style={{ marginLeft: '8px' }} />
            </Row>
          </>
        ) : (
          <>
            <Wrapper>
              <P bigger bold className="margin-bottom">Informações importantes</P>
              <Row align="end">
                <Col>
                  <KeyValue column title="Liquidação" value="Observadas as condições descritas em um ou mais contratos, a liquidação das posições exercidas será realizada de forma exclusivamente financeira, mediante o crédito do valor de liquidação ao titular e o débito do mesmo valor ao lançador, em reais e por contrato ou valor nocional, no dia útil subsequente ao vencimento." />
                  <KeyValue column title="Sobre a entrega de contratos ou entrega física no vencimento" value="Entrega de contratos e/ou física não é aplicável em produtos estruturados referenciados a moedas." />
                  <KeyValue column title="Proventos" value="Proventos não são aplicáveis em produtos estruturados referenciados a moedas." />
                </Col>
                <Col>
                  <KeyValue column title="Margem" value="A chamada de margem, quando aplicável, corresponde ao valor que a B3 entende como necessário para garantia de determinada operação. A chamada de margem é debitada diariamente pela B3, diretamente da conta do cliente junto à XP Investimentos. O valor da chamada de margem é variável e pode aumentar ou diminuir em função da oscilação do mercado. A B3 é a responsável pelo cálculo do valor podendo a XP Investimentos, ao seu exclusivo critério, estabelecer a exigência de garantias adicionais para a manutenção da operação. A B3 é responsável pela lista de ativos aceitos como garantia, podendo a XP Investimentos, ao seu exclusivo critério operacional, aceitar ou não um determinado ativo como garantia. Para execução de operações estruturadas e/ou com derivativos no geral, o cliente deverá possuir recursos suficientes para atender à chamada de margem inicial, bem como as chamadas diárias adicionais feitas pela B3 diretamente na conta do cliente. As demais, deverá o cliente atender, tempestivamente, qualquer solicitação de reforço de garantia feito pela XP Investimentos. Caso o cliente não possua saldo disponível ou ativos livres para atendimento da chamada de margem ou reforço de garantia, sua conta junto à XP Investimentos ficará negativa, com a incidência da multa sobre saldo devedor. A não regularização do saldo devedor autoriza a liquidação compulsória da posição do cliente pela XP Investimentos, conforme regra prevista no Contrato de Intermediação assinado pelo cliente quando da abertura da conta." />
                </Col>
              </Row>
            </Wrapper>

            <Wrapper>
              <Glossary />
            </Wrapper>
          </>
        )}
      </ContentBox>
    </Container>
  );
}

export default Informations;
